import React, { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import { toast } from "react-toastify";

import useDisplay from "../../hooks/useDisplay";
import { route } from "./../../router/route";

import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "./../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import Pagination from "../../components/molecules/pagination";
import LSRgBody01 from "./../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import { consultingTabList } from "../../constant/consultingTabList";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import PretendardText from "../../components/atoms/text/pretendardText";
import LSRgBody02 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody02";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import InputLabel from "../../components/atoms/input/inputLabel";
import InputField from "../../components/atoms/input/inputField";
import Checkbox from "./../../components/atoms/input/checkbox";
import PrimaryBtn from "./../../components/atoms/button/primaryBtn";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import ConfirmModal from "../../components/templates/modals/confirmModal";
import SelectBox from "../../components/organisms/SelectBox";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSRgCaption03 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption03";
import Empty from "../../components/molecules/empty";

import TermApi from "../../api/term.api";
import ConsultingApi from "../../api/consulting.api";
import FileApi from "../../api/file.api";

import { errorHandler } from "../../util/errorHandler";
import { isNull } from "../../util/check";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import { macOSCheck } from "../../util/macOSCheck";

const consultingFileAccept =
  ".jpg,.jpeg,.png,.pdf,.hwp,.hwpx,.doc,.docx,.xls,.xlsx";
const consultingFileExtensions = new Set(
  consultingFileAccept.split(",").map((extension) => extension.slice(1)),
);
const consultingFileMaxSize = 20 * 1024 * 1024;

const ConsultingProgress = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [postList, setPostList] = useState([]);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 5, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    consultingTabList[3].title,
  );

  const [btnDisabled, setBtnDisabled] = useState(true);

  const [file01, setFile01] = useState(null);
  const [file02, setFile02] = useState(null);
  const [file03, setFile03] = useState(null);
  const [file04, setFile04] = useState(null);
  const [file05, setFile05] = useState(null);

  const [hopeDate, setHopeDate] = useState("");
  const [hopeDateErrorM, setHopeDateErrorM] = useState("");

  const [agree01, setAgree01] = useState(false);

  const [isPreConsulting, setIsPreConsulting] = useState(false);
  const [isCompleteModal, setIsCompleteModal] = useState(false);
  const [isPreCheckModal, setIsPreCheckModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (
      agree01 &&
      file01 &&
      file02 &&
      file03 &&
      hopeDate &&
      hopeDateErrorM === ""
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [agree01, file01, file02, file03, hopeDate, hopeDateErrorM]);

  //이미지 추가, 삭제
  const inputFile = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop()?.toLowerCase();
    if (!consultingFileExtensions.has(extension)) {
      toast("이미지, PDF, 한글, Word, Excel 파일만 업로드할 수 있습니다.");
      e.target.value = "";
      return;
    }
    if (file.size > consultingFileMaxSize) {
      toast("파일은 한 개당 20MB 이하만 업로드할 수 있습니다.");
      e.target.value = "";
      return;
    }

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (value) => {
      switch (type) {
        case 1:
          setFile01({
            file: file,
            fileUrl: value.target.result,
          });
          break;

        case 2:
          setFile02({
            file: file,
            fileUrl: value.target.result,
          });
          break;

        case 3:
          setFile03({
            file: file,
            fileUrl: value.target.result,
          });
          break;

        case 4:
          setFile04({
            file: file,
            fileUrl: value.target.result,
          });
          break;

        case 5:
          setFile05({
            file: file,
            fileUrl: value.target.result,
          });
          break;

        default:
          break;
      }
    };
    e.target.value = "";
  };

  useEffect(() => {
    if (hopeDate.length > 0) {
      const regex = /^20\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/;
      const year = Number(hopeDate.slice(0, 4));
      const month = Number(hopeDate.slice(4, 6));
      const day = Number(hopeDate.slice(6, 8));
      const date = new Date(year, month - 1, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (
        !regex.test(hopeDate) ||
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day ||
        date < today
      ) {
        return setHopeDateErrorM("오늘 이후의 올바른 날짜를 입력해주세요.");
      }

      setHopeDateErrorM("");
    }
  }, [hopeDate]);

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") return;
    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("컨설팅 서류를 제출하려면 로그인을 해주세요.");
      navigate(route.login, {
        replace: true,
        state: { path: window.location.href },
      });
      return;
    }

    getTermData();
    isConsultingCheckFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [termData, setTermData] = useState({});

  const getTermData = async () => {
    try {
      const response = (await TermApi.getDetail(8)).data.data.content;

      setTermData(response);
    } catch (error) {
      console.error(error);
    }
  };

  const isConsultingCheckFunc = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        consultingStatus: "READY",
      };

      const response = (await ConsultingApi.getMyConsultingList(data)).data
        .data;

      if (response && response?.totalCount > 0) {
        setIsPreConsulting(false);
      } else {
        setIsPreConsulting(true);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const dataListFunc = async () => {
    try {
      const data = {
        page: page,
        size: pagination.size,
        consultingStatus: "SUBMIT",
      };

      const response = (await ConsultingApi.getMyConsultingList(data)).data
        .data;

      setPostList(response.content ?? []);
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / prev.size),
      }));
    } catch (error) {
      errorHandler(error);
    }
  };

  const formatDate = (date) => {
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);
    return `${year}-${month}-${day}`;
  };

  const addMyConsultingSubmitFunc = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const request01 = {
        page: 1,
        size: 1,
        consultingStatus: "READY",
      };

      const response = (await ConsultingApi.getMyConsultingList(request01)).data
        .data.content;

      if (response && response.length > 0) {
        const data = {
          hopeDate: formatDate(hopeDate),
        };

        const selectedFiles = [file01, file02, file03, file04, file05];
        const uploadResults = await Promise.all(
          selectedFiles.map((fileData) =>
            fileData?.file ? fileUpload(fileData.file) : null,
          ),
        );

        uploadResults.forEach((result, index) => {
          if (!result) return;
          const fileNumber = index + 1;
          data[`fileOriginFileName${fileNumber}`] = result.imageOriginFileName;
          data[`fileServerFileName${fileNumber}`] = result.imageServerFileName;
        });

        await ConsultingApi.addMyConsultingFile(response[0].id, data);
        await dataListFunc();
        await isConsultingCheckFunc();

        setFile01(null);
        setFile02(null);
        setFile03(null);
        setFile04(null);
        setFile05(null);
        setHopeDate("");
        setHopeDateErrorM("");
        setAgree01(false);

        setIsCompleteModal(true);
      } else {
        toast("사전 상담을 먼저 진행해주세요.");
      }
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // 파일 업로드
  const fileUpload = async (file) => {
    try {
      const response = (await FileApi.fileUpload(file, "consulting")).data.data;

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    } catch (error) {
      errorHandler(error);
      throw error;
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              marginBottom: 32,
            }}
          >
            📋 1:1 컨설팅
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {consultingTabList.map((tab, index) => (
                <StyledCategoryItem
                  key={index}
                  onClick={() => navigate(tab.path)}
                  isActive={index === 3 ? true : false}
                  title={tab.title}
                />
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <ContentContainer>
              <ContentWrapper>
                <ContentHeaderWrapper>
                  <LSBdDisplay02 style={{ color: "#101113" }}>
                    필요 서류 제출
                  </LSBdDisplay02>
                  <LSRgH1HeadLine style={{ color: "#474747" }}>
                    컨설팅 당일로부터 2일 전까지 제출 부탁드립니다.
                  </LSRgH1HeadLine>
                </ContentHeaderWrapper>

                <InputContainer>
                  <InputLabel
                    style={{
                      width: 447,
                    }}
                  >
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        컨설팅 희망 날짜
                      </LSBdH1HeadLine>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <InputField
                      id="date"
                      name="date"
                      placeholder="YYYYMMDD"
                      type="text"
                      autoComplete="off"
                      required={true}
                      value={hopeDate}
                      isWarring={hopeDateErrorM !== ""}
                      warringMsg={hopeDateErrorM}
                      onChange={(e) => {
                        setHopeDate(e.target.value);
                      }}
                    />
                  </InputLabel>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          토스 신용점수 캡쳐화면
                        </LSBdH1HeadLine>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputFileWrapper>
                        <LSBdH1HeadLine
                          style={{
                            marginTop: macOSCheck() ? 0 : 2,
                            color: "#5050ff",
                          }}
                        >
                          파일 업로드
                        </LSBdH1HeadLine>
                        <img
                          src="/assets/icons/clip.png"
                          alt="파일 업로드"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                          }}
                        />
                        <InputFile
                          id={"file01"}
                          type="file"
                          accept={consultingFileAccept}
                          onChange={(e) => {
                            inputFile(e, 1);
                          }}
                        />
                      </InputFileWrapper>
                      {file01 ? (
                        <LSRgBody02 style={{ color: "#101113" }}>
                          {file01.file.name}
                        </LSRgBody02>
                      ) : null}
                    </InputLabel>
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          토스 신용점수 캡쳐화면 아래 대출상세내역
                        </LSBdH1HeadLine>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputFileWrapper>
                        <LSBdH1HeadLine
                          style={{
                            marginTop: macOSCheck() ? 0 : 2,
                            color: "#5050ff",
                          }}
                        >
                          파일 업로드
                        </LSBdH1HeadLine>
                        <img
                          src="/assets/icons/clip.png"
                          alt="파일 업로드"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                          }}
                        />
                        <InputFile
                          id={"file02"}
                          type="file"
                          accept={consultingFileAccept}
                          onChange={(e) => {
                            inputFile(e, 2);
                          }}
                        />
                      </InputFileWrapper>
                      {file02 ? (
                        <LSRgBody02 style={{ color: "#101113" }}>
                          {file02.file.name}
                        </LSRgBody02>
                      ) : null}
                    </InputLabel>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          보유부동산 및 가계상황
                        </LSBdH1HeadLine>
                        <LSRgBody02 style={{ color: "#101113" }}>
                          (양식 다운로드: http://naver.me/5jmhPXz1)
                        </LSRgBody02>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputFileWrapper>
                        <LSBdH1HeadLine
                          style={{
                            marginTop: macOSCheck() ? 0 : 2,
                            color: "#5050ff",
                          }}
                        >
                          파일 업로드
                        </LSBdH1HeadLine>
                        <img
                          src="/assets/icons/clip.png"
                          alt="파일 업로드"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                          }}
                        />
                        <InputFile
                          id={"file03"}
                          type="file"
                          accept={consultingFileAccept}
                          onChange={(e) => {
                            inputFile(e, 3);
                          }}
                        />
                      </InputFileWrapper>
                      {file03 ? (
                        <LSRgBody02 style={{ color: "#101113" }}>
                          {file03.file.name}
                        </LSRgBody02>
                      ) : null}
                    </InputLabel>
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          사업자 등록증 (사업자일 경우)
                        </LSBdH1HeadLine>
                      </InputTitleWrapper>
                      <InputFileWrapper>
                        <LSBdH1HeadLine
                          style={{
                            marginTop: macOSCheck() ? 0 : 2,
                            color: "#5050ff",
                          }}
                        >
                          파일 업로드
                        </LSBdH1HeadLine>
                        <img
                          src="/assets/icons/clip.png"
                          alt="파일 업로드"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                          }}
                        />
                        <InputFile
                          id={"file04"}
                          type="file"
                          accept={consultingFileAccept}
                          onChange={(e) => {
                            inputFile(e, 4);
                          }}
                        />
                      </InputFileWrapper>
                      {file04 ? (
                        <LSRgBody02 style={{ color: "#101113" }}>
                          {file04.file.name}
                        </LSRgBody02>
                      ) : null}
                    </InputLabel>
                  </div>

                  <InputLabel
                    style={{
                      width: 447,
                    }}
                  >
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        최근 결산기 부가가치세 과세표준증명원 (사업자일 경우)
                      </LSBdH1HeadLine>
                    </InputTitleWrapper>
                    <InputFileWrapper>
                      <LSBdH1HeadLine
                        style={{
                          marginTop: macOSCheck() ? 0 : 2,
                          color: "#5050ff",
                        }}
                      >
                        파일 업로드
                      </LSBdH1HeadLine>
                      <img
                        src="/assets/icons/clip.png"
                        alt="파일 업로드"
                        style={{
                          width: 16,
                          height: 16,
                          objectFit: "cover",
                        }}
                      />
                      <InputFile
                        id={"file05"}
                        type="file"
                        accept={consultingFileAccept}
                        onChange={(e) => {
                          inputFile(e, 5);
                        }}
                      />
                    </InputFileWrapper>
                    {file05 ? (
                      <LSRgBody02 style={{ color: "#101113" }}>
                        {file05.file.name}
                      </LSRgBody02>
                    ) : null}
                  </InputLabel>

                  <InputLabel>
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        개인정보 수집 및 이용 동의(필수)
                      </LSBdH1HeadLine>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <AgreementContainer>
                      <AgreementWrapper className="custom-scrollbar">
                        <PretendardText
                          style={{
                            fontWeight: 400,
                            fontSize: 12,
                            lineHeight: "19.2px",
                            letterSpacing: "-0.6px",
                            color: "#A4A8B1",
                          }}
                        >
                          {termData?.content || ""}
                        </PretendardText>
                      </AgreementWrapper>
                    </AgreementContainer>
                    <Checkbox
                      id="privacyAgree"
                      name="privacyAgree"
                      checked={agree01}
                      value="Agree"
                      valueText="개인정보 수집 및 이용에 동의합니다."
                      onChange={() => {
                        setAgree01(!agree01);
                      }}
                      required={true}
                      style={{ marginTop: 6 }}
                    />
                  </InputLabel>
                </InputContainer>
                <SubmitBtnWrapper>
                  <PrimaryBtn
                    disabled={btnDisabled || isSubmitting}
                    btnText={isSubmitting ? "제출 중" : "제출하기"}
                    onClick={() => {
                      let isLogin = sessionStorage.getItem("isLogin");
                      if (isLogin === "true") {
                        if (isPreConsulting) {
                          setIsPreCheckModal(true);
                        } else {
                          addMyConsultingSubmitFunc();
                        }
                      } else {
                        toast("글쓰기를 위해 로그인을 해주세요.");
                        navigate(`${route.login}`, {
                          state: { path: window.location.href },
                        });
                      }
                    }}
                  />
                </SubmitBtnWrapper>
              </ContentWrapper>

              <TableWrapper>
                <ContentHeaderWrapper>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <LSRgDisplay02>이전 컨설팅 내역</LSRgDisplay02>
                  </div>
                  <LSRgH2HeadLine>
                    이전 진행한 컨설팅 내역을 확인하실 수 있습니다.
                  </LSRgH2HeadLine>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 테이블 */}
                <Table>
                  <tbody>
                    {postList.length > 0 ? (
                      postList.map((item, index) => (
                        <Tr
                          key={index}
                          style={{
                            borderTop: index === 0 && "1px solid #dbdde0",
                          }}
                        >
                          <td
                            style={{
                              marginRight: 312,
                            }}
                          >
                            <LSRgH2HeadLine
                              style={{
                                color: "#101113",
                                width: 575,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                navigate(
                                  `${route.consulting_progress_detail}/${item.id}`,
                                );
                              }}
                            >
                              {item.necessaryPart}
                            </LSRgH2HeadLine>
                          </td>
                          <td
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: 88,
                            }}
                          >
                            <LSRgBody01 style={{ color: "#898E99" }}>
                              {moment(item.createdAt).format("YYYY.MM.DD")}
                            </LSRgBody01>
                          </td>
                        </Tr>
                      ))
                    ) : (
                      <Empty title={"이전 컨설팅 내역이 없습니다."} />
                    )}
                  </tbody>
                </Table>

                {postList.length > 0 && (
                  <Pagination
                    route={route.consulting_progress}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </TableWrapper>
            </ContentContainer>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>📋 1:1 컨설팅</LSRgH1HeadLine>
              <SelectBox
                style={{
                  width: "100%",
                }}
                subMenuStyle={{
                  width: "100%",
                }}
                isSmall={true}
                isOpen={subMenuBoxOpen}
                isLink={true}
                selectedValue={selectedSubMenu}
                wrapperHandler={() => {
                  setSubMenuBoxOpen(!subMenuBoxOpen);
                }}
                itemList={consultingTabList}
                selectedValueSetterFunc={setSelectedSubMenu}
              />
            </ContentHeaderWrapper>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              <LSRgH1HeadLine>사전 상담 신청</LSRgH1HeadLine>
              <LSRgBody01 style={{ color: "#101113" }}>
                컨설팅 당일로부터 2일 전까지 제출 부탁드립니다.
              </LSRgBody01>
            </div>

            <InputContainer $isSmall={isSmall}>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    컨설팅 희망 날짜
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputField
                  id="date"
                  name="date"
                  placeholder="YYYYMMDD"
                  type="text"
                  autoComplete="off"
                  required={true}
                  value={hopeDate}
                  isWarring={hopeDateErrorM !== ""}
                  warringMsg={hopeDateErrorM}
                  onChange={(e) => {
                    setHopeDate(e.target.value);
                  }}
                />
              </InputLabel>

              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    토스 신용점수 캡쳐화면
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputFileWrapper $isSmall={isSmall}>
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#5050ff",
                    }}
                  >
                    파일 업로드
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                  <InputFile
                    id={"file01"}
                    type="file"
                    accept={consultingFileAccept}
                    onChange={(e) => {
                      inputFile(e, 1);
                    }}
                  />
                </InputFileWrapper>
                {file01 ? (
                  <LSRgBody02 style={{ color: "#101113" }}>
                    {file01.file.name}
                  </LSRgBody02>
                ) : null}
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    토스 신용점수 캡쳐화면 아래 대출상세내역
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputFileWrapper $isSmall={isSmall}>
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#5050ff",
                    }}
                  >
                    파일 업로드
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                  <InputFile
                    id={"file02"}
                    type="file"
                    accept={consultingFileAccept}
                    onChange={(e) => {
                      inputFile(e, 2);
                    }}
                  />
                </InputFileWrapper>
                {file02 ? (
                  <LSRgBody02 style={{ color: "#101113" }}>
                    {file02.file.name}
                  </LSRgBody02>
                ) : null}
              </InputLabel>

              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    보유부동산 및 가계상황
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <LSRgCaption03 style={{ color: "#101113" }}>
                  (양식 다운로드: http://naver.me/5jmhPXz1)
                </LSRgCaption03>
                <InputFileWrapper $isSmall={isSmall}>
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#5050ff",
                    }}
                  >
                    파일 업로드
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                  <InputFile
                    id={"file03"}
                    type="file"
                    accept={consultingFileAccept}
                    onChange={(e) => {
                      inputFile(e, 3);
                    }}
                  />
                </InputFileWrapper>
                {file03 ? (
                  <LSRgBody02 style={{ color: "#101113" }}>
                    {file03.file.name}
                  </LSRgBody02>
                ) : null}
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    사업자 등록증 (사업자일 경우)
                  </LSBdH1HeadLine>
                </InputTitleWrapper>
                <InputFileWrapper $isSmall={isSmall}>
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#5050ff",
                    }}
                  >
                    파일 업로드
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                  <InputFile
                    id={"file04"}
                    type="file"
                    accept={consultingFileAccept}
                    onChange={(e) => {
                      inputFile(e, 4);
                    }}
                  />
                </InputFileWrapper>
                {file04 ? (
                  <LSRgBody02 style={{ color: "#101113" }}>
                    {file04.file.name}
                  </LSRgBody02>
                ) : null}
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    최근 결산기 부가가치세 과세표준증명원{" "}
                  </LSBdH1HeadLine>
                  <LSRgCaption03 style={{ color: "#101113" }}>
                    (사업자일 경우)
                  </LSRgCaption03>
                </InputTitleWrapper>
                <InputFileWrapper $isSmall={isSmall}>
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#5050ff",
                    }}
                  >
                    파일 업로드
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                  <InputFile
                    id={"file05"}
                    type="file"
                    accept={consultingFileAccept}
                    onChange={(e) => {
                      inputFile(e, 5);
                    }}
                  />
                </InputFileWrapper>
                {file05 ? (
                  <LSRgBody02 style={{ color: "#101113" }}>
                    {file05.file.name}
                  </LSRgBody02>
                ) : null}
              </InputLabel>

              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    개인정보 수집 및 이용 동의(필수)
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <AgreementContainer>
                  <AgreementWrapper className="custom-scrollbar">
                    <PretendardText
                      style={{
                        fontWeight: 400,
                        fontSize: 12,
                        lineHeight: "19.2px",
                        letterSpacing: "-0.6px",
                        color: "#A4A8B1",
                      }}
                    >
                      {termData?.content || ""}
                    </PretendardText>
                  </AgreementWrapper>
                </AgreementContainer>
                <Checkbox
                  id="privacyAgree"
                  name="privacyAgree"
                  checked={agree01}
                  value="Agree"
                  valueText="개인정보 수집 및 이용에 동의합니다."
                  onChange={() => {
                    setAgree01(!agree01);
                  }}
                  required={true}
                  style={{ marginTop: 6 }}
                />
              </InputLabel>
            </InputContainer>
            <SubmitBtnWrapper $isSmall={isSmall}>
              <PrimaryBtn
                disabled={btnDisabled || isSubmitting}
                btnText={isSubmitting ? "제출 중" : "제출하기"}
                onClick={() => {
                  let isLogin = sessionStorage.getItem("isLogin");
                  if (isLogin === "true") {
                    if (isPreConsulting) {
                      setIsPreCheckModal(true);
                    } else {
                      addMyConsultingSubmitFunc();
                    }
                  } else {
                    toast("글쓰기를 위해 로그인을 해주세요.");
                    navigate(`${route.login}`, {
                      state: { path: window.location.href },
                    });
                  }
                }}
              />
            </SubmitBtnWrapper>

            <TableWrapper $isSmall={isSmall}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  margin: "60px 0px 20px 0px",
                }}
              >
                <LSRgH1HeadLine>이전 컨설팅 내역</LSRgH1HeadLine>
                <LSRgBody01>
                  이전 진행한 컨설팅 내역을 확인하실 수 있습니다.
                </LSRgBody01>
              </div>

              {/* 본문 영역 - 테이블 */}
              <Table $isSmall={isSmall}>
                <tbody>
                  {postList.length > 0 ? (
                    postList.map((item, index) => (
                      <Tr
                        key={index}
                        $isSmall={isSmall}
                        style={{
                          borderTop: index === 0 && "1px solid #dbdde0",
                        }}
                      >
                        <td
                          style={{
                            display: "flex",
                            width: 315,
                            flexDirection: "column",
                            gap: 10,
                          }}
                        >
                          <LSRgBody01
                            style={{
                              width: 315,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => {
                              navigate(
                                `${route.consulting_progress_detail}/${item.id}`,
                              );
                            }}
                          >
                            {item.necessaryPart}
                          </LSRgBody01>
                          <div
                            style={{
                              display: "flex",
                              paddingLeft: 68,
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                              }}
                            >
                              <img
                                style={{
                                  width: 14,
                                  height: 14,
                                  objectFit: "cover",
                                }}
                                src={"/assets/icons/user.png"}
                                alt={"작성자"}
                              />
                              <LSRgBody01
                                style={{
                                  width: 86,
                                  color: "#898E99",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.name}
                              </LSRgBody01>
                            </div>
                            <LSRgBody01 style={{ width: 88, color: "#898E99" }}>
                              {moment(item.createdAt).format("YYYY.MM.DD")}
                            </LSRgBody01>
                          </div>
                        </td>
                      </Tr>
                    ))
                  ) : (
                    <Empty title={"이전 컨설팅 내역이 없습니다."} />
                  )}
                </tbody>
              </Table>

              {postList.length > 0 && (
                <Pagination
                  route={route.consulting_progress}
                  queryString={``}
                  currentPage={Number(page) || 1}
                  totalPages={pagination.totalPages}
                  rangeSize={pagination.rangeSize}
                />
              )}
            </TableWrapper>
          </ContentContainer>
        </MOContainer>
      )}

      {/* 모달 */}
      {isCompleteModal && (
        <ConfirmModal
          isScroll={false}
          title={"필요 서류 제출 완료!"}
          content={"필요 서류가 정상적으로 제출되었습니다."}
          isAlert={true}
          onYClick={() => {
            setIsCompleteModal(false);
          }}
        />
      )}

      {isPreCheckModal ? (
        <ConfirmModal
          isScroll={false}
          title={"사전 상담을 먼저\n진행해주세요."}
          content={"서류를 제출할 사전 상담 내역이 없습니다."}
          onClick={() => {
            setIsPreCheckModal(false);
          }}
          onYClick={() => {
            setIsPreCheckModal(false);
            navigate(route.consulting_prior);
          }}
        />
      ) : null}
    </HomeSection>
  );
};

export default ConsultingProgress;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 995px;
  height: fit-content;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  padding: 60px 40px;
  margin-bottom: 60px;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "10px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const TableWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
`;

const Table = styled.table.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  border-spacing: 0px;
  border-collapse: collapse;
`;

const Tr = styled.tr.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: ${(props) => (props.$isSmall ? "76px" : "64px")};
  border-bottom: 1px solid #dbdde0;
  padding: 16px 10px;
  display: flex;
  align-items: center;
`;

const InputContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: ${(props) => (props.$isSmall ? "20px" : "2px")};
`;

const InputTitleWrapper = styled.div.attrs((props) => {})`
  padding-left: 5px;
  display: flex;
  gap: 2px;
`;

const InputTitleRequiredDot = styled.span.attrs((props) => {})`
  width: 4px;
  height: 4px;
  background-color: #f24147;
  border-radius: 50%;
`;

const InputFileWrapper = styled.div.attrs((props) => {})`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #5050ff;
  border-radius: 15px;
  width: ${(props) => (props.$isSmall ? "335px" : "447px")};
  height: 56px;
  gap: 10px;
  cursor: pointer;
`;

const InputFile = styled.input.attrs((props) => {})`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

const AgreementContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: 125px;
  border: 1px solid #dbdde0;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

const AgreementWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 95px;
  overflow-y: auto;
`;

const SubmitBtnWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  width: 100%;
  margin-top: ${(props) => (props.$isSmall ? "28px" : "50px")};
`;
